<!--在线用户-->
<template>
  <el-drawer
    class="sideDrawer"
    :size="drawerSize"
    destroy-on-close
    :close-on-click-modal="false"
    :title="title"
    :visible="show"
    :before-close="beforeCloseDialog"
    @dialogclose="beforeCloseDialog"
    append-to-body
  ><i
      class="iconfont icon-back-quanping iconFull"
      @click="drawerSize = '100%'"
      v-if="drawerSize == '70%'"
    />
    <i
      @click="drawerSize = '70%'"
      class="iconfont icon-back-tuichuquanping iconFull"
      v-else
    />
    <div
      class="form_content"
      style="padding: 10px 20px"
    >
      <div
        ref="tablePanel"
        class="fullheight"
      >
        <div class="table_content">
          <el-table
            ref="ecoTable"
            :style="{
              height: `${tableMaxHeight}` + 'px'
            }"
            :max-height="tableMaxHeight"
            :data="templateData"
            tooltip-effect="dark"
            style="width: 100%"
            border
            :header-cell-style="headerCellStyle"
          >
            <el-table-column
              type="index"
              label="序号"
              width="55"
            >
            </el-table-column>
            <el-table-column
              v-for="(item,index) in tableheader"
              :prop="item.prop"
              align="center"
              :label="item.label"
              :key="index"
            >
            </el-table-column>
          </el-table>
          <div
            class="page_bean"
            v-if="type !=5"
          >
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="20"
              layout="total, prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'transferDialog',
  computed: {
    $utils() {
      return $utils
    }
  },
  data() {
    return {
      show: false,
      title: '',
      type: '1',
      total: 0,
      pageSize: 20,
      currentPage: 1,
      templateData: [],
      tableheader: [],
      drawerSize: '70%',
      tableMaxHeight: document.body.clientHeight - 150
    }
  },
  mounted() {},

  methods: {
    open(dialogType) {
      this.type = dialogType
      this.currentPage = 1
      this.loadData()
      this.show = true
    },
    beforeCloseDialog() {
      this.show = false
      // this.$emit('closeTransferDialog')
    },
    //表头样式
    headerCellStyle() {
      return {
        backgroundColor: '#F3F3F3',
        color: '#333333'
      }
    },
    //每页数量调整
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    //页数跳转
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 动态计算表格的高度，自适应当前容器
    calcTableHeight(delay) {
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        this.tableMaxHeight = tablePanelHeight - 150
      }, delay || 0)
    },
    //初始化加载
    loadData() {
      this.templateData = []
      this.total = 0
      const param = {
        pageBean: { page: this.currentPage, pageSize: 20, total: 0 }
      }
      switch (this.type) {
        case '1':
          // 岗位未配置用户
          this.title = '岗位未配置用户'
          this.tableheader = [
            {
              prop: 'post_name',
              label: '岗位名称'
            },
            {
              prop: 'post_no',
              label: '岗位编号'
            },
            {
              prop: 'job_name',
              label: '职务名称'
            },
            {
              prop: 'org_path',
              label: '组织路径'
            }
          ]

          this.$http.post('${data}/back/statistics/queryOrgUser', param).then((res) => {
            this.templateData = res.data.rows
            this.currentPage = res.data.page
            this.total = res.data.total
          })
          break
        case '2':
          // 角色未分配用户
          this.title = '角色未分配用户'

          this.tableheader = [
            {
              prop: 'role_name',
              label: '角色名称'
            },
            {
              prop: 'role_no',
              label: '角色编号'
            },
            {
              prop: 'remark',
              label: '描述'
            }
          ]

          this.$http.post('${data}/back/statistics/queryRoleUser', param).then((res) => {
            this.templateData = res.data.rows
            this.currentPage = res.data.page
            this.total = res.data.total
          })
          break
        case '3':
          // 用户岗位为空
          this.title = '用户岗位为空'

          this.tableheader = [
            {
              prop: 'fullname',
              label: '名称'
            },
            {
              prop: 'account',
              label: '账号'
            },
            {
              prop: 'mobile',
              label: '电话'
            },
            {
              prop: 'sex',
              label: '性别'
            }
          ]

          this.$http.post('${data}/back/statistics/queryUserPost', param).then((res) => {
            this.currentPage = res.data.page
            this.templateData = res.data.rows
            this.total = res.data.total
          })
          break
        case '4':
          // 用户角色为空
          this.title = '用户角色为空'

          this.tableheader = [
            {
              prop: 'fullname',
              label: '名称'
            },
            {
              prop: 'account',
              label: '账号'
            },
            {
              prop: 'mobile',
              label: '电话'
            },
            {
              prop: 'sex',
              label: '性别'
            }
          ]

          this.$http.post('${data}/back/statistics/queryUserRole', param).then((res) => {
            this.templateData = res.data.rows
            this.currentPage = res.data.page
            this.total = res.data.total
          })
          break
        case '5':
          // 未配置的流程节点
          this.title = '未配置的流程节点'

          this.tableheader = [
            {
              prop: 'name',
              label: '流程名称'
            },
            {
              prop: 'version',
              label: '版本号'
            },
            {
              prop: 'node_name',
              label: '审批节点'
            }
          ]

          this.$http.post('${data}/back/statistics/queryBpmNode', param).then((res) => {
            this.currentPage = 1
            this.templateData = res.data
          })
          break
      }
    }
  }
}
</script>

<style scoped>
.top_search {
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.col_style {
  height: 100%;
  display: flex;
  align-items: center;
}
/deep/.el-input-group__append button.el-button {
  border-color: transparent;
  background-color: #377cff;
  color: white;
  border-top: 0;
  border-bottom: 0;
}
.button_group {
  height: 40px;
  display: flex;
  justify-content: right;
  align-items: center;
}
.page_bean {
  display: flex;
  justify-content: right;
  align-items: center;
}
</style>
